'use client';
import Link from 'next/link';
import { useTranslations } from '../utils/translations';

export default function TagsSection({ className = '' }: { className?: string }) {
  const { t } = useTranslations();
  
  return (
    <section className={`w-full ${className}`}>
      <div className="w-full max-w-[1400px] mx-auto px-4 sm:px-6 md:px-[214px]">
        <div className="flex flex-wrap gap-[15px] sm:gap-[15px] md:gap-[15px] justify-center items-start text-center">
          {/* First Row of Links */}
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.honest_tarot')}
            </Link>
          </div>
          
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.card_divination')}
            </Link>
          </div>
          
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="/cards-gallery" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.lenormand_cards')}
            </Link>
          </div>
          
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.tarot_cards')}
            </Link>
          </div>

          {/* Special bordered link */}
          <div className="flex flex-col gap-[40px] sm:gap-[46px] md:gap-[52px] justify-start items-center">
            <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
              <Link 
                href="#" 
                className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
              >
                {t('home.tags.online_tarot_reading')}
              </Link>
            </div>
            
          </div>

          {/* More services */}
          <div className="flex flex-col gap-[38px] sm:gap-[44px] md:gap-[50px] justify-start items-start">
            <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
              <Link 
                href="/" 
                className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
              >
                {t('home.tags.tarot_online')}
              </Link>
            </div>
            
          </div>
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.tarot_advisor')}
            </Link>
          </div>
          
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.free_tarot_reading')}
            </Link>
          </div>
          
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.tarot_love')}
            </Link>
          </div>
          
          <div className="flex justify-center items-center border border-[#7f7f7f] rounded px-2 py-1">
            <Link 
              href="#" 
              className="text-[10px] sm:text-[11px] md:text-[12px] font-inter font-normal leading-[12px] sm:leading-[13px] md:leading-[15px] text-[#7f7f7f] hover:text-[var(--text-primary)] transition-colors duration-200"
            >
              {t('home.tags.tarot_decision')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}